import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useProfileSetup } from '../contexts/ProfileContext';
import LoadingSpinner from '../components/loading-spinner/LoadingSpinner';

export default function ProtectedRoute({ children, requiredRoles }) {
  const { user, loading } = useAuth();
  const { userRole } = useProfileSetup();

   if (loading) {
      return (
        <div className="p-4 flex items-center justify-center min-h-[40vh]">
          <LoadingSpinner />
        </div>
      );
    }
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles && !requiredRoles.includes(userRole)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
